import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import numeral from "numeral";
import $ from 'jquery'
import flot from 'flot'
import Loading from 'vue-loading-overlay' //component
import 'vue-loading-overlay/dist/vue-loading.css' //style

Vue.filter("formatNumber", function (value) {
  return numeral(value).format("0.00"); // displaying other groupings/separators is possible, look at the docs 
});

Vue.filter("formatMoney", function (value) {
  return numeral(value).format("0.0"); // displaying other groupings/separators is possible, look at the docs 
});

Vue.component('Loading', Loading)

window.$ = $;

Vue.use(VueAxios, axios, flot);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
